export default "__VITE_ASSET__DWdylH2V__"